import { useMemo } from 'react';
import { useRouter } from 'next/router';
import useHeaderMenuData from '@/creditflowresearch/application/HeaderMenu/useHeaderMenuData';
import Region from '@/creditflowresearch/domain/Region';
import SectionService from '@/creditflowresearch/domain/Header/Section';
import { ISection } from '@creditflowresearch/uilib/Section';
import { getCurrentPath } from '@framework/router';
import { applyActiveStateToSections } from '@/creditflowresearch/ui/common/utils/panels/applyActiveStateToSections';

interface IUsePanelSectionsOptions {
  panelId: string,
  regionId?: string,
}

export const usePanelSections = ({
  panelId,
  regionId = Region.getDefaultId(),
}: IUsePanelSectionsOptions): ISection[][][] => {
  const {
    sectorsMenu,
    industriesMenu,
    mapping,
    isHeaderInitialized,
  } = useHeaderMenuData();
  const { asPath } = useRouter();
  const currentPath = getCurrentPath(asPath);

  const sectionsGrid = useMemo(() => {
    const validation = SectionService.validateSectionData(
      mapping,
      panelId,
      isHeaderInitialized,
      regionId,
      sectorsMenu,
      industriesMenu,
    );

    if (!validation.isValid || !validation.activeMapping || !validation.profilesMenu) {
      return [];
    }

    const transformedSections = SectionService.transformProfilesToSections(validation.profilesMenu, {
      activeProductAbbreviation: validation.activeMapping.productAbbreviation,
      activeRegionAbbreviation: validation.activeMapping.regionAbbreviation,
      activeMapping: validation.activeMapping,
      filterType: validation.activeMapping.filterType,
    });

    return applyActiveStateToSections(transformedSections, currentPath);
  }, [
    panelId,
    regionId,
    mapping,
    isHeaderInitialized,
    sectorsMenu,
    industriesMenu,
    currentPath,
  ]);

  return sectionsGrid;
};

export type { IUsePanelSectionsOptions };
